import { render, staticRenderFns } from "./FrsHeader.vue?vue&type=template&id=9b55144c&scoped=true&lang=html&"
import script from "./FrsHeader.vue?vue&type=script&lang=js&"
export * from "./FrsHeader.vue?vue&type=script&lang=js&"
import style0 from "./FrsHeader.vue?vue&type=style&index=0&id=9b55144c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b55144c",
  null
  
)

export default component.exports